var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3DBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2498 11.27C26.2424 10.9885 26.078 10.7348 25.824 10.6132L16.7023 6.2444C15.9399 5.87929 15.0521 5.88503 14.2945 6.25997L5.16735 10.7774C4.91503 10.9023 4.7539 11.1579 4.75011 11.4395C4.74995 11.4511 4.75006 11.4626 4.75044 11.4741C4.75015 11.4827 4.75 11.4914 4.75 11.5L4.75 22.08C4.75 22.3579 4.90367 22.613 5.14933 22.7429L14.2001 27.5303C15.0152 27.9614 15.9921 27.9554 16.8018 27.5141L25.8588 22.5786C26.0999 22.4472 26.25 22.1946 26.25 21.92L26.25 11.5C26.25 11.4642 26.2475 11.429 26.2427 11.3945C26.2484 11.3537 26.2509 11.312 26.2498 11.27ZM6.25 21.6282L6.25 12.6947L14.2001 16.8999C14.3769 16.9934 14.5614 17.0663 14.75 17.1187L14.75 26C14.75 26.0444 14.7539 26.0879 14.7613 26.1302L6.25 21.6282ZM16.2419 26.111L24.75 21.4746L24.75 12.5524L16.8018 16.8837C16.6247 16.9802 16.4397 17.0559 16.25 17.1107L16.25 26C16.25 26.0377 16.2473 26.0748 16.2419 26.111ZM23.8536 11.3326L16.0841 15.5666C15.716 15.7671 15.272 15.7699 14.9015 15.5739L7.14602 11.4717L14.9599 7.60432C15.3042 7.43389 15.7078 7.43128 16.0543 7.59724L23.8536 11.3326Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DBox);
export default __webpack_public_path__ + "static/media/3d-box.d5b53c7890076d5dc467e6450e046545.svg";
export { ForwardRef as ReactComponent };